import React from "react";
export var ControlType;
(function (ControlType) {
    ControlType["previous"] = "previous";
    ControlType["next"] = "next";
})(ControlType || (ControlType = {}));
